module.exports = __webpack_public_path__ + "static/media/BookIcon.cb864a8b.png";